"use client";

import Link from "next/link";
import React from "react";
import FooterLogo from "../../../public/assets/img/logo/logo-2.png";
import Image from "next/image";
import CopyrightArea from "./copyright-area";
import { getLink, Routes } from "@/constants";
import { usePathname } from "next/navigation";

const MemoFooter = () => {
  const pathname = usePathname();
  const locale = pathname?.split("/").filter(Boolean)[0] || "en";

  return (
    <>
      <footer>
        <div className="footer__area footer-bg">
          <div className="footer__top pt-10 pb-10">
            <div className="container">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "18px",
                  flexWrap: "wrap",
                  padding: "10px 0 2px",
                }}
              >
                {/*<Link
                  href={getLink(locale, Routes.THE_TEAM)}
                  style={{
                    color: "rgba(255,255,255,0.85)",
                    fontWeight: 600,
                    letterSpacing: "0.01em",
                  }}
                >
                  Meet the Team
                </Link>
                */}
              </div>
            </div>
          </div>
          <CopyrightArea />
        </div>
      </footer>
    </>
  );
};

export default MemoFooter;
